/**
 * Format a duration in minutes to a human-readable string.
 * e.g. 60 → "1 hr", 90 → "1 hr 30 min", 45 → "45 min", 120 → "2 hrs"
 */
export function formatDuration(minutes) {
  if (!minutes || minutes <= 0) return '0 min';
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hrs === 0) return `${mins} min`;
  if (mins === 0) return `${hrs} hr${hrs > 1 ? 's' : ''}`;
  return `${hrs} hr${hrs > 1 ? 's' : ''} ${mins} min`;
}


/**
 * Format an address value to a display string.
 * Handles both structured objects {line1, line2, city, postcode} and plain strings.
 */
export function formatAddress(addr) {
  if (!addr) return '';
  if (typeof addr === 'string') return addr;
  if (typeof addr === 'object') {
    return [addr.line1, addr.line2, addr.city, addr.postcode].filter(Boolean).join(', ');
  }
  return String(addr);
}
